import { useQuery } from "@tanstack/react-query";
import { BulkTest } from "@/model";
import bulkTestRepository from "@/repository/bulkTestRepository";


const getData = async (scenarioId: string): Promise<BulkTest[]> => {
    const response = await bulkTestRepository.getScenarioTest(scenarioId);
    return response.data?.content ?? [];
};

export const useBulkTests = (scenarioId: string) => {
    return useQuery<BulkTest[]>({
        queryKey: ["bulk-tests", "paginated", scenarioId],
        queryFn: () => getData(scenarioId),
        retry: false
    });
};
